import React from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

export interface ErrorRetryCardProps {
  message: string;
  retryLabel: string;
  onRetry: () => void;
  className?: string;
}

// Card partilhado de erro com accao de retry (reutilizado por Lite, Insights Pro
// e DashboardHome). Usa role="alert" para acessibilidade e para os testes.
const ErrorRetryCard: React.FC<ErrorRetryCardProps> = ({ message, retryLabel, onRetry, className }) => (
  <Card role="alert" className={className ?? 'border-amber-200 bg-amber-50 shadow-sm'}>
    <CardContent className="space-y-4 p-6 text-center">
      <p className="text-sm text-amber-800">{message}</p>
      <Button onClick={onRetry} className="bg-action-700 text-white hover:bg-action-800">
        <RefreshCw className="mr-2 h-4 w-4" />
        {retryLabel}
      </Button>
    </CardContent>
  </Card>
);

export default ErrorRetryCard;
